import axios from "axios";
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import exportFromJSON from "export-from-json";
import { Col, Container, Row } from "react-bootstrap";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { GlobalContext } from "../../../context/GlobalState";
import "./StudentSubmissionReport.css";
import { ReportHeader } from "./Component/ReportHeader";
import { Question } from "./Component/Questions/Question";
import { useAlert } from "react-alert";

import "./EvaluateReport.css";
import "./Media.css";
import SummaryEvaluationBox from "./Component/SummaryEvaluation";

//Working on OT marking
const StudentSubmissionReport = () => {
  const history = useHistory();
  const alert = useAlert();
  const { userDetails } = useContext(GlobalContext);
  const params = useParams();
  const location = useLocation();
  const [submission, setSubmission] = useState(null);
  const isSmallScreen = useMediaQuery({
    query: "(max-width:450px)",
  });
  const [evaluating, setEvaluating] = useState(false);

  const checkQuestion = useCallback(
    (questionId, response = {}) => {
      if (!submission || !submission.answers) return;
      const answerIndex = (submission.answers || []).findIndex(
        (answer) => answer.questionId === questionId,
      );
      if (answerIndex < 0) return;
      submission.answers[answerIndex] = {
        ...submission.answers[answerIndex],
        ...response,
      };
      setSubmission({ ...submission, answers: [...submission.answers] });
    },
    [submission?.answers],
  );

  const evaluatationStatus = useMemo(() => {
    return (submission?.answers || []).reduce(
      (acc, curr) => {
        acc.studentScore += curr.marks || 0;
        if (!["incorrect", "correct"].includes(curr.status))
          acc.canSubmit = false;
        return acc;
      },
      { studentScore: 0, canSubmit: true },
    );
  }, [submission?.answers]);

  const submitEvaluation = async (feedback) => {
    if (evaluating) return;
    setEvaluating(true);
    submission.feedback = feedback;
    const checks = submission.answers.reduce((acc, curr) => {
      acc[curr.questionId] = {
        status: curr.status,
        marks: curr.marks,
        feedback: curr.feedback,
      };
      return acc;
    }, {});
    const authToken = localStorage.getItem("authToken");
    try {
      await axios.post(
        `${process.env.REACT_APP_RANDOMIZE_ORIGIN}/api/v1/staffs/${userDetails.userId}/assignTests/${params.assignTestId}/submissions/${params.submissionId}`,
        { checks, feedback },
        {
          headers: {
            token: authToken,
          },
        },
      );
      alert.show("Evaluation submitted successfully!", { type: "success" });
      setEvaluating(false);
      history.replace(`/report/reportcard/${submission.assignTest}`);
    } catch (error) {
      alert.show(error.message, { type: "error" });
    }
    setEvaluating(false);
  };

  const query = useMemo(() => {
    const searchQuery = new URLSearchParams(location.search);
    return {
      grade: searchQuery.get("grade"),
      student: searchQuery.get("student"),
      studentId: searchQuery.get("studentId"),
      test: searchQuery.get("test"),
      category: searchQuery.get("category"),
    };
  }, [location]);

  const fetchSubmission = async () => {
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_RANDOMIZE_ORIGIN}/api/v1/staffs/${
          userDetails.userId
        }/assignTests/${params.assignTestId}/submissions/${
          params.submissionId
        }?category=${query.category || "cbq"}`,
        {
          headers: {
            token: authToken,
          },
        },
      );
      if (response.data.status === "success") {
        const submission = response.data.data.submission;
        setSubmission(submission);
      }
      return;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSubmission();
  }, []);

  useEffect(() => {
    console.log(evaluating);
  }, [evaluating]);

  return (
    <>
      <br />
      <ReportHeader
        isSmallScreen={isSmallScreen}
        heading={query.grade}
        subheading={query.student}
        description={query.test}
      />
      <Container className="mx-auto container">
        {(submission?.questionSet?.questions || []).map((qt, index) => {
          const attempt = submission.answers.find(
            (ans) => ans?.questionId === qt.questionId?._id,
          );
          return (
            <Question
              index={index + 1}
              question={qt.questionId}
              attempt={attempt}
              mark={qt.marks}
              checkQuestion={checkQuestion}
            />
          );
        })}
        {submission ? (
          <SummaryEvaluationBox
            loading={evaluating}
            totalScore={submission?.totalMarks || 0}
            studentScore={evaluatationStatus.studentScore}
            defaultFeedback={submission?.feedback || ""}
            onSubmit={submitEvaluation}
            canSubmit={evaluatationStatus.canSubmit}
          />
        ) : null}
        <br />
        <br />
      </Container>
    </>
  );
};

export default StudentSubmissionReport;
